import dayjs from 'dayjs';

/**
 * Utility functions for date handling in hover components
 * Uses dayjs for consistency with the rest of the codebase
 */

/**
 * Formats epoch timestamp or date string using app config date format
 * This follows the existing pattern used throughout the codebase
 */
export function formatDateForTooltip(date: string | number, dateFormat?: string): string {
    try {
        if (typeof date === 'number') {
            // Handle epoch timestamp using dayjs.unix() - follows existing codebase pattern
            // Examples from codebase: dayjs.unix(item?.created_at).format(commonConfig?.dateFormat)
            return dayjs
                .unix(date)
                .utc()
                .startOf('day')
                .format(dateFormat || 'MM/DD/YYYY');
        }

        if (typeof date === 'string') {
            // Handle ISO date strings or other string formats
            return dayjs(date).format(dateFormat || 'MM/DD/YYYY');
        }

        console.warn('Invalid date type for tooltip:', date);
        return 'Invalid Date';
    } catch (error) {
        console.warn('Error formatting date for tooltip:', date, error);
        return 'Invalid Date';
    }
}

/**
 * Validates if a value can be parsed as a date
 */
export function isValidDateValue(date: any): boolean {
    try {
        if (typeof date === 'number') {
            const formatted = dayjs.unix(date);
            return formatted.isValid();
        }

        if (typeof date === 'string') {
            const formatted = dayjs(date);
            return formatted.isValid();
        }

        return false;
    } catch {
        return false;
    }
}
